import { useEffect } from "react";

// ref: https://shipshape.io/blog/wait-for-page-load-in-react/g
export const useOnPageLoad = (fn: () => void) => {
  useEffect(() => {
    // Check if the page has already loaded
    if (document.readyState === "complete") {
      fn();
      return;
    } else {
      window.addEventListener("load", fn);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", fn);
    }
  }, [fn]);
};
